define([
	"dojo/_base/declare",
	"csi/table/New"
], function(declare,New) {
	var CUSTOMER = "Customer";
	var SALES_DIVISION = "SalesDivision";
	return declare(New, {
		onCreatePopup: function(/*csi.view.Widget*/view) {
			var srcNode = this.getParent();

			if (srcNode.Market) {
				view.addFixedValue("Market", srcNode.Market);
			} else if (srcNode.$Type == CUSTOMER) {
				view.addFixedValue("Buyer", srcNode.$URL);
			} else if (srcNode.$Type == SALES_DIVISION) {
				view.addFixedValue("Seller", srcNode.$URL);
			}
			this.inherited(arguments);
		}
	});
});